import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { http } from "@/lib/api";
import { Columns3, X } from "lucide-react";
import { useIdList, COMPARE_KEY } from "@/lib/idList";

export const CompareBar = () => {
  const { ids, toggle, clear } = useIdList(COMPARE_KEY, 3);
  const loc = useLocation();
  const [titles, setTitles] = useState(null);
  useEffect(() => {
    if (ids.length && !titles) http.get("/careers").then((r) => setTitles(Object.fromEntries(r.data.careers.map((c) => [c.id, c.title])))).catch(() => setTitles({}));
  }, [ids.length, titles]);
  if (!ids.length || loc.pathname === "/careers/compare") return null;
  return (
    <div className="fixed bottom-5 inset-x-0 z-40 px-4 no-print" data-testid="compare-bar">
      <div className="max-w-3xl mx-auto rounded-full bg-[#1C242B] text-[#FAF8F5] shadow-2xl ps-5 pe-2 py-2 flex items-center gap-3 animate-in slide-in-from-bottom-4 duration-300">
        <Columns3 size={18} className="text-[#F0A584] shrink-0" />
        <div className="flex-1 flex gap-2 overflow-x-auto">
          {ids.map((id) => (
            <span key={id} className="shrink-0 inline-flex items-center gap-1 rounded-full bg-white/10 ps-3 pe-1 py-1 text-xs">
              {titles?.[id] || id}
              <button onClick={() => toggle(id)} aria-label="Remove" data-testid={`compare-bar-remove-${id}`} className="p-0.5 rounded-full hover:bg-white/20"><X size={12} /></button>
            </span>
          ))}
        </div>
        <button onClick={clear} data-testid="compare-bar-clear" className="text-xs text-slate-300 hover:text-white px-2">Clear</button>
        {ids.length >= 2 ? (
          <Link to={`/careers/compare?ids=${ids.join(",")}`} data-testid="compare-bar-go" className="shrink-0 rounded-full bg-[#D96B43] px-5 py-2 text-sm font-semibold hover:bg-[#C05630] transition-colors">Compare</Link>
        ) : <span className="shrink-0 text-xs text-slate-400 pe-3">Pick one more</span>}
      </div>
    </div>
  );
};
